<template>
  <div id="general-part">

    <general-information v-model="data"
                         :editable="editable"
                         :infrastructure="infrastructure"
                         :validation="$v"/>

    <b-card body-bg-variant="light"
            header="Team"
            header-bg-variant="dark"
            header-text-variant="light">
      <b-row align-h="center">
        <team-form v-if="proposalObjectId"
                   :editable="editable"
                   :proposal-object-id="proposalObjectId"/>
        <b-spinner v-else
                   variant="info"/>
      </b-row>
    </b-card>

    <affiliation v-model="data"
                 :editable="editable"
                 @save-proposal="saveProposal"/>

    <experiment-discipline v-model="data"
                           :disciplines-prop="disciplines"
                           :editable="editable"
                           :validation="$v"/>

    <experimental-infrastructure-form v-model="data"
                                      :editable="editable"
                                      :validation="$v"/>

    <scientific-part v-model="data"
                     :editable="editable"
                     :validation="$v"/>

    <equipment v-model="data"
               :editable="editable"
               :validation="$v"/>

    <publications-section v-model="data"
                          :editable="editable"
                          :validation="$v"/>

    <additional-info v-model="data"
                     :editable="editable"
                     :validation="$v"/>

    <preferred-time v-model="data"
                    :editable="editable"/>

  </div>
</template>

<script>
  import TeamForm from '@/components/TeamForm';
  import { synchrotronProposalValidator } from '@/assets/validators/synchrotronProposalValidator';
  import Equipment from '@/components/proposal/proposals/general/equipment/Equipment';
  import affiliation from '@/components/proposal/proposals/general/affiliation/affiliation';
  import ExperimentalInfrastructureForm
    from '@/components/proposal/proposals/general/experimental-infrastructure/ExperimentalInfrastructureForm';
  import PublicationsSection from '@/components/proposal/proposals/general/publications/PublicationsSection';
  import PreferredTime from '@/components/proposal/proposals/general/preferred-time/PreferredTime';
  import AdditionalInfo from '@/components/proposal/proposals/general/additional-info/AdditionalInfo';
  import ScientificPart from '@/components/proposal/proposals/general/scientific-part/ScientificPart';
  import GeneralInformation from '@/components/proposal/proposals/general/general-information/GeneralInformation';
  import ExperimentDiscipline from '@/components/proposal/proposals/general/experiment-discipline/ExperimentDiscipline';
  import disciplines from '@/json/disciplines';
  import { hasProperty } from '@/helpers';

  export default {
    props: {
      value: undefined,
      editable: undefined,
      infrastructure: undefined,
    },
    components: {
      TeamForm,
      ScientificPart,
      Equipment,
      PublicationsSection,
      affiliation,
      AdditionalInfo,
      PreferredTime,
      GeneralInformation,
      ExperimentalInfrastructureForm,
      ExperimentDiscipline,
    },
    data() {
      return {
        data: {
          general: {
            synchrotron_experience_bool: '',
            preferred_time: [],
            undesirable_period: [],
          },
          team: [],
        },
        disciplines,
      };
    },
    computed: {
      proposalObjectId() {
        return hasProperty(this.value, '_id') ? this.getId(this.value) : '';
      },
    },
    watch: {
      value: {
        handler() {
          this.data = this.value;
          if (this.data.general === undefined) {
            this.data.general = {};
          }
        },
        deep: true,
      },
    },
    methods: {
      saveProposal() {
        this.$emit('save-proposal');
      },
    },
    validations: synchrotronProposalValidator,
  };
</script>
